import gql from 'graphql-tag';

export const ExperimentalUpdateShortcuts =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation ExperimentalUpdateShortcuts(
			$spaceKey: String!
			$quickLinks: [ExperimentalSpaceSidebarLink]
		) @experimental {
			experimentalUpdateShortcutLinks(spaceKey: $spaceKey, quickLinks: $quickLinks) {
				quickLinks {
					id
					url
					position
					title
					styleClass
				}
				__typename
			}
		}
	`;
